/**
 * Moduł do zarządzania statusem mobilnym
 *
 * @export
 * @class MobileModule
 */
export class ConfirmModule {
  /**
   * Domyślny stan modułu
   *
   * @private
   * @memberof ConfirmModule
   */
  private defaultState = {
    confirm: undefined
  };

  /**
   * Stan modułu
   *
   * @memberof ConfirmModule
   */
  public state = {
    ...this.defaultState
  };

  public mutations = {
    showConfirm(localState: any, payload: any) {
      if (payload.closeButton === undefined) {
        payload.closeButton = 'buttons.no';
      }
      if (payload.submitButton === undefined) {
        payload.submitButton = 'buttons.yes';
      }
      localState.confirm = payload;
    }
  };

  public actions = {
    showConfirm(context: any, value: any) {
      context.commit('showConfirm', value);
    }
  };

  public getters = {};
}

export default new ConfirmModule();
